import type { IntelligenceSettingsState } from '@core/intelligence-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

export const {
  reducer: IntelligenceSettingsReducer,
  actions: IntelligenceSettingsActions,
  selectors: IntelligenceSettingsSelectors,
  namespace: IntelligenceSettingsNamespace,
} = createSingleEntityStore<IntelligenceSettingsState>()('IntelligenceSettingsState');
